const scrollToElement = (elementId: string): void => {
    const elementDiv = document.getElementById(elementId);

    if (elementDiv) {
        setTimeout(() => {
            elementDiv.scrollIntoView({ behavior: 'smooth' });
        }, 0);
    }
};

export default scrollToElement;
